module.exports = __webpack_public_path__ + "img/image14.3e635140.jpg";